export const postsData = {
    mvSlider: ["01", "02"],
    news: [],
    character: [],
    story: [],
    music: [
        {
            head: "オープニング主題歌",
            image: "music/ph_1.webp",
            title: "『skirt』",
            artist: "aiko",
            details: [
                {
                    title: "作詞・作曲",
                    text: "AIKO",
                },
                {
                    title: "編曲",
                    text: "島田 昌典",
                },
            ],
        },
        {
            head: "エンディング主題歌",
            image: "music/ph_2.webp",
            title: "『カプセル』",
            artist: "aiko ",
            details: [
                {
                    title: "作詞・作曲",
                    text: "AIKO",
                },
                {
                    title: "編曲",
                    text: "島田 昌典",
                },
            ],
        },
    ],
};
